import { render, staticRenderFns } from "./tellCommand.vue?vue&type=template&id=ca19e5a8&scoped=true"
import script from "./tellCommand.vue?vue&type=script&lang=js"
export * from "./tellCommand.vue?vue&type=script&lang=js"
import style0 from "./tellCommand.vue?vue&type=style&index=0&id=ca19e5a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca19e5a8",
  null
  
)

export default component.exports